module.exports = __webpack_public_path__ + "fonts/Calibre-Black.36ffd75d.woff2";